export let allCollectedScenes = 0;
export const openedPopups = {};

export function popupInit() {
  const popup = document.querySelector(".popup.main-popup")
  const popupHeadline = popup.querySelector(".headline")
  const popupParagraph = popup.querySelector(".paragraph")
  const popupImage = popup.querySelector(".media img")
  const popupVideo = popup.querySelector(".media video")
  const popupIframe = popup.querySelector(".media iframe")
  const popupClose = popup.querySelector(".close")

  function closePopup() {
    popup.setAttribute('hidden','true');
    popup.setAttribute('area-hidden','true');
    popup.setAttribute('tabindex','-1');
    popup.blur();
    popup.classList.remove("active", 'video', 'image', 'iframe')
    popupImage.src = "";
    popupVideo.src = "";
    popupIframe.src = "";
    // region allow page scroll
    document.dispatchEvent(new Event('scroll-enabled'));
    setTimeout(() => document.documentElement.classList.remove('modal-opened'), 50)
    // endregion allow page scroll
  }

  popupClose.addEventListener("click", closePopup)

  window.addEventListener('keydown', (e) => {
    if (e.key === "Escape" && document.documentElement.classList.contains('modal-opened')) {
      closePopup()
    }
  })
  const posters = document.querySelectorAll(".poster")

  return (block, clickableItems) => {
    const init = clickableItems.length;
    const pulseEffectElements = block.querySelectorAll("[data-clickable]")
    for (let i = 0; i < pulseEffectElements.length; i++) {

      const element = pulseEffectElements[i];
      init || element.matches(':not([data-not-collectable])') && clickableItems.push(false)
      element.addEventListener("click", () => {
        if (!element.matches('[data-no-popup]')) {
          popupHeadline.innerText = element.dataset.popupHeadline;
          popupParagraph.innerHTML = element.dataset.popupParagraph;
          element.dataset?.popupImage && (popupImage.src = element.dataset?.popupImage);
          element.dataset?.popupVideo && (popupVideo.src = element.dataset?.popupVideo);
          element.dataset?.popupIframe && (popupIframe.src = element.dataset?.popupIframe);
          popup.classList.add(...[
            'active',
            element.dataset?.popupImage && 'image',
            element.dataset?.popupVideo && 'video',
            element.dataset?.popupIframe && 'iframe',
          ].filter(i => i))
          popup.setAttribute('hidden','false');
          popup.setAttribute('area-hidden','false');
          popup.setAttribute('tabindex','0');
          popup.focus();
          // region prevent page scroll
          document.documentElement.classList.add('modal-opened');
          document.dispatchEvent(new Event('scroll-disabled'));

          // endregion prevent page scroll

        }

        if (!element.matches('[data-not-collectable]')) {
          const GTMPopupData = {
            'event': 'open-popup',
            'scene': window.currentScene+1,
            'popup': i+1,
            'headline': element.dataset.popupHeadline
          }
          window.allowGTM && window.dataLayer.push(GTMPopupData);
          delete GTMPopupData.event
          openedPopups[element.dataset.popupHeadline] = GTMPopupData

          clickableItems[i] = true;
          const clickedItems = clickableItems.filter(i => i).length;
          window.dispatchEvent(new CustomEvent('trigger-clicked', {detail: clickedItems}))

          if (clickableItems.length === clickedItems && !posters[window.currentScene].classList.contains('active')) {
            window.dispatchEvent(new Event('scene-completed'))
            allCollectedScenes += 1;
          }
        }
      })

      try {
        element.dataset?.popupImage && fetch(element.dataset?.popupImage);
        element.dataset?.popupVideo && fetch(element.dataset?.popupVideo);
      } catch (e) {
        console.log(e);
      }
    }
  }


}
